import { createItemStore } from '~/utils/pinia/item-store'
import type { FantasyShopSet } from '~/types/fantasy'

export const useFantasyShopSetStore = createItemStore<'id', FantasyShopSet>(
  'fantasy-shop-set',
  {
    path: id => `/api/v1/fantasy/shop/sets/${id}`,
    query: {
      expand: ['cards', 'grades']
    }
  }
)
